module.exports = __webpack_public_path__ + "static/about-us-template-2-0cf8274880fbbcd0c6b0f0fc09a6ee19.png";